import axios from 'axios'
import LYCom from '../common/LYCom'
import {
  MessageBox
} from 'element-ui';

const service = axios.create({
  // baseURL: LYCom.CallBizCfg.SvrRoot,
  timeout: LYCom.CallBizCfg.Timeout
})

service.interceptors.request.use(
  config => {
    // 获取服务地址
    let arr = config.url.split("/");
    let svrId = arr[0];
    let svrItem = LYCom.GetSvrById(svrId);
    if (svrItem) {
      config.baseURL = svrItem.Address;
    }
    if (arr.length == 4) {
      config.url = arr[1] + "/" + arr[2] + "/" + arr[3];

    } else {
      config.url = arr[1] + "/" + arr[2];

    }
    let token = window.sessionStorage.getItem("token");
    if (token) {
    
      config.headers['ly-token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data;

    if (res.code && res.code != 200) {
      // 判断token是否失效，
      if (res.code == 402) {
        console.log(MessageBox);
        MessageBox('您当前登录已过期，是否重新登录', '确定', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 清空token 刷新页面
          window.sessionStorage.removeItem("token");
          location.reload()
        })
      }
      return Promise.resolve(res)
    } else {
      return Promise.resolve(res)
    }
  },
  error => {

    return error
  }
)

export default service



// WEBPACK FOOTER //
// ./src/request/index.js